import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

/**
 * Shared layout for legal / info pages.
 * Children render inside a clean editorial column with consistent typography.
 */
export default function LegalLayout({ eyebrow, title, lastUpdated, children, testid }) {
  return (
    <div className="min-h-screen">
      <Nav />
      <section className="max-w-3xl mx-auto px-6 sm:px-10 py-16 lg:py-24" data-testid={testid}>
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#525252] hover:text-[#0A0A0A]">
          <ArrowLeft className="w-4 h-4" /> Back to book
        </Link>
        {eyebrow && (
          <div className="mt-8 text-[11px] uppercase tracking-[0.3em] font-bold text-[#D92D20]">{eyebrow}</div>
        )}
        <h1 className="mt-3 font-display font-black tracking-tighter text-4xl sm:text-5xl leading-[0.95]">
          {title}
        </h1>
        {lastUpdated && (
          <div className="mt-4 text-xs font-mono-plex uppercase tracking-[0.2em] text-[#737373]">
            Last updated · {lastUpdated}
          </div>
        )}
        <div className="mt-10 space-y-6 text-[#0A0A0A] text-base leading-relaxed legal-prose">
          {children}
        </div>
      </section>
      <Footer />
    </div>
  );
}
